<template>
  <div>
    <jump-header />
    <div class="page-body">
      <div class="page-wrapper">
        <div class="frequency-header">
          <div class="frequency-header-left">
            <img :src="program.pictureUrl" />
            <div class="frequency-header-left-data">
              <span class="frequency-header-left-data-title">{{
                program.name
              }}</span>
              <span class="frequency-header-left-data-num">
                <i
                  class="v-icon-play-circle-o"
                  :style="{ marginRight: '5px', color: 'lightcoral' }"
                />
                &nbsp;{{ program._clickSum }}
              </span>
            </div>
          </div>
          <div class="frequency-header-right" @click="toSevenDaysRecord">
            <i class="v-icon-play-o" />
            <span class="frequency-header-right-desc">7日回听</span>
          </div>
        </div>

        <!-- 正在直播 -->
        <div class="content-title">正在直播</div>
        <div class="live">
          <div
            class="live-item"
            v-for="item in programMenulist"
            :key="item.startTime"
            @click="toLiving(item)"
          >
            <img :src="item.pictureUrl" />
            <div class="live-item-tag">
              <span
                class="live-item-tag-desc"
                :class="{ notLiving: isLiving(item) !== '直播中' }"
                >{{ item.liveStatus }}</span
              >
              <span class="live-item-tag-time"
                >{{ item.startTime }}-{{ item.endTime }}</span
              >
            </div>
            <div class="live-item-title">{{ item.name }}</div>
            <div class="live-item-anchor">
              <i class="live-item-anchor-icon v-icon-anchor" />
              <div class="live-item-anchor-text text-line-1">
                {{ item.nickname }}
              </div>
            </div>
          </div>
        </div>

        <!-- 热门主播 -->
        <div class="activity-title-wraper">
          <div class="activity-title">热门主播</div>
        </div>

        <div class="hotAnchor" style="display: flex" ref="hotAnchor">
          <div
            class="hotAnchor-wrapper"
            v-for="item in anchorList"
            :key="item.id"
            @click="toAnchorPage(item)"
          >
            <div class="fans-tag">
              <div class="fans-tag-desc">
                <i class="v-icon-hot" />
              </div>
            </div>
            <div class="hotAnchor-top">
              <img :src="item.publicImage" />
              <div class="anchor-item-name">{{ item.nickName }}</div>
              <div class="anchor-item-desc text-line-1">
                {{ item.description }}
              </div>
            </div>
            <div
              class="focus-button"
              :class="{ 'focus-button-inactive': item.isCare == 1 }"
            >
              {{ item.isCare == 1 ? "已关注" : "+ 关注" }}
            </div>
          </div>
          <div class="click-more">
            <div class="more">查看更多</div>
            <span class="more-desc">More</span>
          </div>
        </div>

        <div class="activity-title-wraper">
          <div class="activity-title">热门节目</div>
        </div>
        <div
          v-for="item in programList"
          :key="item.id"
          @click="handleClickRecordItem(item)"
        >
          <div class="recommend-item">
            <div class="item-img">
              <img :src="item.pictureUrl" alt="" />
            </div>
            <div class="item-right">
              <div class="item-title">{{ item.name }}</div>
              <div class="item-desc">{{ item.nickname }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import wxSdk from "@/http/wxApi.js";
import { useRoute, useRouter } from "vue-router";
import { defineComponent, onMounted, ref } from "vue";
import JumpHeader from "@/components/Base/JumpHeader";
import {
  queryRadioStationAndProgramByCode,
  queryProgramMenuPoolCurrentAndLeft,
  popularHostsTopAllByRadio,
  popularProgramAllMoreByRadio,
} from "@/http/api";

export default defineComponent({
  name: "RateSpecial",
  components: {
    JumpHeader,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const program = ref({});
    const anchorList = ref([]);
    const programList = ref([]);
    const programMenulist = ref([]);
    const radioStationCode = ref("962");

    const codeStr = {
      962: "FM96.2",
      1027: "FM102.7",
      1061: "FM106.1",
      88: "FM88.0",
    };

    const getProgramByCode = async () => {
      const { data } = await queryRadioStationAndProgramByCode({
        radioStationCode: radioStationCode.value,
      });
      if (data.code === 1) {
        program.value = data.data;
        program.value._clickSum = fixNumToBig(program.value.clickSum);
      }
    };

    const getProgramMenuPoolRest = async () => {
      const result = await queryProgramMenuPoolCurrentAndLeft({
        radioStationCode: radioStationCode.value,
      });
      if (result.data) {
        result.data.forEach((item) => {
          item.liveStatus = liveStatus(item);
        });
        programMenulist.value = result.data;
      }
    };

    const getAnchorList = async () => {
      const result = await popularHostsTopAllByRadio({
        radioStationCode: radioStationCode.value,
      });
      if (result.code === 1) {
        anchorList.value = result.data.hostVoList;
      }
    };

    const getPopularProgramList = async () => {
      const { code, data } = await popularProgramAllMoreByRadio({
        radioStationCode: radioStationCode.value,
        type: "all",
      });
      console.log("热门节目");
      console.log(data);
      if (code === "1") {
        programList.value = data.programVoList;
      }
    };

    const liveStatus = (item) => {
      let date = new Date();
      let hours =
        date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      let mins =
        date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      let nowTime = `${hours}:${mins}`;
      if (item.startTime < nowTime && nowTime < item.endTime) {
        return "直播中";
      } else if (item.startTime > nowTime) {
        return "预播中";
      } else {
        return "重播中";
      }
    };

    const fixNumToBig = (val) => {
      if (val > 10000) {
        return `${(val / 10000).toFixed(2)}万`;
      }
      return val;
    };

    // 是否为直播中
    function isLiving(item) {
      let date = new Date();
      let hours =
        date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      let mins =
        date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      let nowTime = `${hours}:${mins}`;
      if (item.startTime < nowTime && nowTime < item.endTime) {
        return "直播中";
      } else if (item.startTime > nowTime) {
        return "预播中";
      } else {
        return "重播中";
      }
    }

    const toAnchorPage = (item) => {
      router.push({
        name: "Anchor",
        query: {
          id: item.hostUserId,
        },
      });
    };

    const toLiving = (item) => {
      if (item.liveStatus !== "直播中") {
        Toast("节目预播中");
      } else {
        router.push({
          name: "LivingDetail",
          query: {
            code: item.radioStationCode,
            programId: item.id,
          },
        });
      }
    };

    const handleClickRecordItem = (item) => {
      console.log(item);
      router.push({
        name: "LivingDetail",
        query: {
          code: item.radioStationCode,
          programId: item.id,
          playType: "playRecord",
        },
      });
    };

    const wxShare = () => {
      const _program = program.value;
      wxSdk.getJSSDK({
        title: _program.name,
        desc: `${_program.information} ${codeStr[_program.code]}`,
        linkurl: `https://app.gztv.com/hcfmshare/#/RateSpecial?code=${_program.code}`,
        img: _program.pictureUrl,
      });
    };

    onMounted(async () => {
      radioStationCode.value = route.query.code;
      await getProgramByCode();
      getProgramMenuPoolRest();
      getAnchorList();
      getPopularProgramList();
      wxShare();
    });

    return {
      program,
      anchorList,
      programList,
      toAnchorPage,
      programMenulist,
      isLiving,
      toLiving,
      handleClickRecordItem,
    };
  },
});
</script>

<style lang="scss" scoped>
.page-wrapper {
  width: 100%;
  padding-top: 5px;
}
.page-body {
  margin: 60px auto 0;
  max-width: 450px;
}

.frequency-header {
  margin: 0 13px;
  overflow: hidden;
  display: flex;
  width: calc(100% - 26px);
  height: 140px;
  justify-content: space-between;
  align-items: center;

  &-left {
    display: flex;
    flex: 1;

    img {
      min-width: 120px;
      height: 120px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.15);
    }

    &-data {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 120px;
      justify-content: center;
      // @include layout-setting(flex, column, 100%, 120px, center, stretch);
      padding-left: 20px;

      &-title {
        font-size: 22px;
        font-weight: bold;
      }

      &-num {
        display: flex;
        align-items: center;
        padding-top: 15px;
        font-size: 14px;
        color: #999;
        float: left;

        &-icon {
          margin-right: 4px;
          color: #fa3d70;
        }
      }
    }
  }

  &-right {
    display: flex;
    flex-direction: column;
    height: 120px;
    align-items: center;
    font-size: 15px;
    justify-content: center;

    .v-icon-play-o {
      font-size: 16px;
    }

    &-desc {
      font-size: 14px;
      margin-top: 8px;
    }
  }
}

.content-title {
  width: calc(100% - 26px);
  margin: 0 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 18px;
  font-weight: bold;
}

// 直播模块
.live {
  width: 100%;
  // margin-left: 13px;
  display: flex;
  overflow: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 5px;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */

  // &::-webkit-scrollbar {
  //   display: none; /* Chrome Safari */
  // }

  &-item {
    position: relative;
    width: 140px;
    min-width: 140px;
    height: 190px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 3px 4px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-right: 13px;

    &:first-child {
      margin-left: 13px;
    }

    img {
      width: 100%;
      height: 140px;
    }

    &-tag {
      position: absolute;
      top: 100px;
      left: 5px;
      display: flex;
      align-items: center;
      border-radius: 5px;
      font-size: 12px;
      color: #fa3d70;
      background: rgba(0, 0, 0, 0.5);

      &-desc {
        font-size: 10px;
        padding: 4px 5px;
        border-radius: 4px;
        color: #fa3d70;
      }

      &-time {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 14px;
        padding: 4px 5px 4px 4px;
      }
    }

    &-title {
      margin-top: 5px;
      display: block;
      text-align: center;
      width: 100%;
      font-size: 14px;
      color: black;
    }

    &-anchor {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 5px;
      overflow: hidden;

      &-icon {
        font-size: 12px;
        color: #bfbfbf;
      }

      &-text {
        font-size: 12px;
        color: #999;
      }
    }
  }
}

.activity-title-wraper {
  display: flex;
  padding: 16px 13px 0px 13px;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.activity-title {
  font-size: 18px;
  font-weight: bold;
}

.hotAnchor {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 210px;
  box-sizing: border-box;
  margin-top: 8px;
  padding-left: 13px;
  overflow: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  align-items: center;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */

  // &::-webkit-scrollbar {
  //   display: none; /* Chrome Safari */
  // }
}

.click-more {
  display: flex;
  width: 70px;
  height: 190px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #e9e9e9;
  font-size: 16px;
  border-radius: 8px;

  .more {
    text-align: center;
    width: 70px;
    font-size: 12px;
    color: #9898a0;
  }
  .more-desc {
    color: #999;
  }
}

.hotAnchor-wrapper {
  position: relative;
  display: flex;
  width: 130px;
  height: 190px;
  padding: 10px 20px 0 20px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  margin-right: 13px;
  box-shadow: 2px 3px 3px #e9e9e9;
  background: lighten(#f1f1f1, 75);
}

.fans-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  font-size: 12px;
  color: #fff;
  background: #fa3d70;
  // @include content-setting(30px, 30px);
  // @include normal-setting(12, #fff, #fa3d70);
  border-radius: 0 8px 0 30px;
  font-weight: bold;

  &-desc {
    transform: translate(2px, -2px);
  }
}
.hotAnchor-top {
  text-align: center;

  img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 1px solid #f5f5f5;
  }
}
.anchor-item-name {
  font-weight: bold;
  font-size: 16px;
}

.focus-button {
  width: 70px;
  line-height: 28px;
  text-align: center;
  background: #ed4014;
  border-radius: 14px;
  font-size: 12px;
  opacity: 0.8;
  color: #fff;
  font-weight: bold;
  margin-bottom: 13px;

  &-inactive {
    background: #c2c2c2;
  }
}

// 热门主播
.lessThan3 {
  width: calc(100% - 26px);
  margin: 0 13px;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
}
.anchor {
  width: calc(100% - 26px);
  margin: 0 13px;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  &-item-less-3 {
    margin-right: 3%;
  }

  &-item {
    display: flex;
    flex-direction: column;
    width: 31%;
    align-items: center;
    justify-content: space-between;
    // @include layout-setting(flex, column, 31%, auto, space-between, center);
    overflow: hidden;
    padding-top: 10px;

    img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;
    }

    &-name {
      font-size: 14px;
      color: black;
      font-weight: bold;
      padding-top: 5px;
    }

    &-desc {
      width: 100px;
      text-align: center;
      font-size: 12px;
      color: #999;
      overflow: hidden;
      padding-top: 8px;
    }

    &-focus {
      margin-top: 5px;
      width: 70px;
      line-height: 28px;
      text-align: center;
      background: #ed4014;
      border-radius: 14px;
      font-size: 14px;
      opacity: 0.8;
      color: #fff;
      font-weight: bold;
      border: 1px solid #ccc;
    }
  }
}

.notLiving {
  color: #2f2f2f;
  background: rgba(255, 255, 255, 0.6);
  font-size: 10px;
}

.recommend-item {
  display: flex;
  align-items: center;
  width: calc(100% - 26px);
  height: 110px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 10px auto 0;
  box-sizing: border-box;
  padding: 0 13px;

  .item-img {
    width: 85px;
    height: 85px;
    border-radius: 8px;

    & > img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }

  .item-right {
    display: flex;
    flex-direction: column;
    height: 85px;
    margin-left: 15px;

    .item-title {
      font-size: 18px;
      color: #111;
      font-weight: bold;
      letter-spacing: 1px;
      text-indent: 1px;
    }

    .item-desc {
      font-size: 12px;
      color: #999;
      margin-top: 15px;
      letter-spacing: 1px;
      text-indent: 1px;
    }
  }
}
</style>
